import { render, staticRenderFns } from "./acuerdo-select.vue?vue&type=template&id=01d4dfb0&scoped=true"
import script from "./acuerdo-select.vue?vue&type=script&lang=js"
export * from "./acuerdo-select.vue?vue&type=script&lang=js"
import style0 from "./acuerdo-select.vue?vue&type=style&index=0&id=01d4dfb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4dfb0",
  null
  
)

export default component.exports